import eyeIcon from './../Assets/icons/eye 1.svg'
import editIcon from './../Assets/icons/Un-Checkbox.svg'

export const TABLE_HEADERS = [
    // "Sr No.",
    "Job Card No.",
    "Dealer Name",
    "Contact No.",
  
    "Vin No.",
  
    "Inspection By",
    "Created At",
   
    "Remark",
    "Status",
    "Action"

  ];
  
  export const TABLE_DATA = [
    { id: 1, days: "One Month", description:"lorem ipsum",status: "Active", actions: "Edit/Delete" },
    { id: 2, days: "Two Month", description:"lorem ipsum",  status: "Inactive", actions: "Edit/Delete" },
    { id: 3, days: "Three Month", description:"lorem ipsum",  status: "Active", actions: "Edit/Delete" },
  ];
  
  export const keyMapping = {
    // "Sr No.": "Sr No.",
    "Job Card No.":"job_card_no",
    "Dealer Name": "dealer_name",
    "Contact No.":"contact_no",
    "PO No.":'po_number',
    "Vin No.":"vin_no",

    "Warranty Name":"warrrenty_name", 
    "Warrenty Type":"warrantyType",
    "Warranty Days":"warrantyDay",
    "Inspection By":"inspection_by",

   "Created At":"created_at",
    
    "Remark":"rejactRemark",  
    "Status": "isApprovedStatus", 
    "Action": [
        { type: "view", icon: eyeIcon, label: "View" },
        
      ]
  };